var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"unicorn",on:{"click":_vm.animate}},[_c('img',{attrs:{"src":require("../../../assets/sloth2.png"),"alt":"","srcset":""}})]),(_vm.isActive)?_c('div',{staticClass:"confetti"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }